import { Pipe, PipeTransform } from '@angular/core';
import { CurrRates } from '../components/models/symbol-model';
@Pipe({
    name: 'currencyName'
})
export class CurrencyNamePipe implements PipeTransform {
    transform(val: CurrRates): string {
        if (val !== undefined && val !== null) {
            return (val.symbolDesc).substring(0, (val.symbolDesc).indexOf('(')) + ' ' + (val.symbol).trim();
        } else {
            return '';
        }
    }
}
